export default __webpack_public_path__ + "fd623a270b6c63805761318d38ed29ed.jpg";